import UserInformationTable from "./UserInformationTable";
import {useContext, useEffect, useState} from "react";
import {toFarsiNumber} from "../cudtom-hooks/en-to-persian";
import {MyContext} from "../context/myContext";
import {useDispatch, useSelector} from "react-redux";
import {selectWaterType, setWaterType} from "../features/request/requestSlice";
import {callApiAgain} from "../features/common-states/commonStatesSlice";

const UserInformation = () => {
    const {bodyArray, title} = useContext(MyContext)
    const [selectedItem, setSelectedItem] = useState('btn2')
    const dispatch = useDispatch()
    const waterType = useSelector(selectWaterType)

    useEffect(() => {
        setSelectedItem(waterType === 1 ? 'btn2' : 'btn1')
    }, [waterType])

    return(
        <div className='user-info'>
            <p className='user-title'>
                <i className="fa fa-angle-double-left"></i>
                <span>{title}</span>
                <i className="fa fa-angle-double-right"></i>
            </p>
            {title === 'درخواست های ثبت شده' &&
                <div className='request-toggle'>
                    <button className={`${selectedItem === 'btn1' && 'active'} left-btn`} onClick={() => {dispatch(setWaterType(2)); dispatch(callApiAgain(true))}}>درخواست های شرب دام</button>
                    <button className={`${selectedItem === 'btn2' && 'active'} right-btn`} onClick={() => {dispatch(setWaterType(1)); dispatch(callApiAgain(true))}}>درخواست های شرب انسان</button>
                </div>
            }
            <UserInformationTable />
            <p className='table-footer'>از بین {bodyArray ? toFarsiNumber(bodyArray.length) : 0} مورد</p>
        </div>
    )
}

export default UserInformation